import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { Location } from '../../shared/models/location.model';
import { SessionService } from '../../shared/services/session.service';
import { SpinnerService } from '../../shared/spinner/spinner.service';

@Component({
    selector: 'schedule-remote',
    template: ``,
    standalone: false
})

export class ScheduleRemoteComponent implements OnInit {
  @Output() locationSelected: EventEmitter<Location> = new EventEmitter<Location>();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private spinnerService: SpinnerService,
    private sessionService: SessionService,
    ) { }

    ngOnInit(): void {
        if (this.sessionService.isSessionInitialized) {
            const locObj= {
                id: 999999999,
                name: 'SCHEDULE_INTERVIEW.REMOTE',
                services: [
                    {
                        name: 'up',
                        operational: true
                    }
                ]
            };

            const loc = new Location(locObj);
            this.sessionService.location = loc;
        } else {
            this.sessionService.sessionInitialized.subscribe((res: boolean) => {
                if (res) {
                    // Create the remote Location
                    const locObj= {
                        id: 999999999,
                        name: 'SCHEDULE_INTERVIEW.REMOTE',
                        services: [
                            {
                                name: 'up',
                                operational: true
                            }
                        ]
                    };

                    const loc = new Location(locObj);

                    // this.locationSelected.emit(loc);
                    this.sessionService.sessionInitialized.unsubscribe();

                    this.sessionService.location = loc;
                }
            });
        }
    }
}
